import * as React from 'react'
import SortableList from './SortableList'
import { DroppableImageRegion } from './DroppableImageRegion'
import config from '../../config'
import { MinimalSortableImageList } from './MinimalSortableImageList'

interface Props {
  maxImages?: number
  images: any
  onDrop?: any
  onSortEnd?: any
  removeImage?: any
  rotateImage?: any
  revertImageEdit?: any
  editImage?: any
  isDisabled?: boolean
  disableUpload?: boolean
  disableEdit?: boolean
  minimal?: boolean
  targetElementSelectorForSticky?: string
}

const Images: React.FC<Props> = ({
  maxImages = config.MAX_IMAGES,
  images,
  onDrop = null,
  onSortEnd = null,
  removeImage = null,
  rotateImage = null,
  revertImageEdit = null,
  editImage = null,
  isDisabled = false,
  disableUpload = false,
  disableEdit = false,
  minimal = false,
  targetElementSelectorForSticky = null
}) => {
  if (minimal) {
    return (
      <MinimalSortableImageList
        targetElementSelectorForSticky={targetElementSelectorForSticky}
        axis="x"
        items={images}
        onSortEnd={onSortEnd}
        rotateImage={rotateImage}
        useDragHandle={false}
        isDisabled={isDisabled}
        distance={10}
      />
    )
  }

  return (
    <div className="position-relative">
      <div className="position-absolute full-height-and-width">
        <DroppableImageRegion
          onDrop={onDrop}
          isDisabled={isDisabled}
          imageCount={images.length}
          maxImages={maxImages}
          className="full-height-and-width dropzone"
        >
          {/* placeholder, which removes our standard dropzone interior */}
          <div />
        </DroppableImageRegion>
      </div>
      {images.length === 0 && !isDisabled && !disableUpload && (
        <div>
          <DroppableImageRegion
            onDrop={onDrop}
            isDisabled={isDisabled}
            imageCount={images.length}
            maxImages={maxImages}
          />
        </div>
      )}
      <SortableList
        axis="xy"
        items={images}
        onSortEnd={onSortEnd}
        rotateImage={rotateImage}
        useDragHandle
        removeImage={removeImage}
        revertImageEdit={revertImageEdit}
        editImage={editImage}
        isDisabled={isDisabled}
        disableEdit={disableEdit}
        distance={10}
      >
        {images.length > 0 && (
          <div className="dropzone-center dropzone-square">
            <DroppableImageRegion
              onDrop={onDrop}
              isDisabled={isDisabled}
              imageCount={images.length}
              maxImages={maxImages}
            />
          </div>
        )}
      </SortableList>
    </div>
  )
}

export default Images
